import * as React from 'react';
import { useState, useEffect } from 'react';
import { Controller, useForm } from "react-hook-form";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FormHelperText } from '@mui/material';

import { SelectTypeInput } from './SelectTypeInput';
import { TextTypeInput } from './TextTypeInput';
import { DocumentFileUpload } from './DocumentFileUpload'
import { StateArray } from '../constant';

export const MCIdDialog = ({
    mcId = [],
    setMCId,
    setOpenDialog,
    index,
    isEditing=false

}) => {


    const [open, setOpen] = useState(false);
    const [mcIdType, setmcIdType] = useState('national');
    const [isNationalAvaibale, setIsNationalAvaible] = useState(true);
    const {
        control,
        handleSubmit,
        formState: { errors, isDirty, isValid },
        getValues,
        setValue,
        reset,
        setError,
        clearErrors
    } = useForm();

    useEffect(() => {
        const mcIdData = mcId?.[index];
        reset({
            mcIdType: mcIdType,
            idName: mcIdData?.idName || '',
            idNumber: mcIdData?.idNumber || '',
            uploadedImages: mcIdData?.uploadedImages, 
            isActive: mcIdData?.isActive || true
          });
    }, [mcIdType]);

    useEffect(() => {
        const mcIdData = mcId?.[index];
        //based on isNationalAvaibale flag we are setting the MCI ID type 
        if(isNationalAvaibale){
            setmcIdType(mcIdData?.mcIdType|| 'national');
        }
        else {
            setmcIdType(mcIdData?.mcIdType ||'state');
        }
    }, [isNationalAvaibale]);

    const handleClickOpen = () => {
        const mcIdData = mcId?.[index];
        //seting MCI ID Type based on idName as backend dont give mcId type flag
        if(mcIdData?.idName.toLowerCase() ==='india'){
            mcIdData.mcIdType = 'national';
        }
        else  if (mcIdData){
            mcIdData.mcIdType = 'state';
        }

        //checking MCI ID for any National ID added if yes dont allow to  add National again
        const mcIdTypeNational = mcId.filter((item) => item.idName.toLowerCase() === 'india' && item.isActive === true);
        if(mcIdTypeNational.length > 0 && !isEditing){
            setIsNationalAvaible(false);
        }
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setOpenDialog?.setOpenDialog(false);
        setIsNationalAvaible(true);
        reset();
    };

    const handleChange = (event) => {
        setmcIdType(event.target.value);
    };

    const handleSubmitForm = (field) => {
        const data = getValues();
        data.isActive = true ;
        setOpen(false);
        if(isEditing){
            setMCId(mcId.map((item, i) => i === index ? { ...item, ...data } : item));
        }
        else{
            setMCId([...mcId, data]);
        }
        setOpenDialog?.setOpenDialog(false);
        setIsNationalAvaible(true);
        reset();
    };
    return (
        <React.Fragment>
            {
                !isEditing ? (<button className=" flex p-2 border rounded-lg border-blue-500 text-sm text-semibold text-blue-700 gap-1 " onClick={(e) => { e.preventDefault(); handleClickOpen() }}>
                    <img src="https://views.medibuddy.in/providerUi/assets/bluePlus.svg" alt="" />
                    <p> Add New </p>
                </button>) :
                    <img src="https://views.medibuddy.in/providerUi/assets/editIcon.svg" alt="Edit" onClick={(e) => { e.preventDefault(); handleClickOpen() }} style={{ cursor: 'pointer' }} />
            }
            <Dialog
                style={{ borderRadius: '16px' }}
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'sm'}
                PaperProps={{
                    component: 'form',
                    style: { borderRadius: '1rem' },
                    onSubmit: (event) => {
                        event.preventDefault();
                        handleClose();
                    },
                }}
            >

                <DialogTitle>
                    <div className="text-xl font-semibold text-left text-[#47566A]">
                        MCI ID
                    </div>

                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <div className="flex flex-col " style={{ gap: '1.5rem' }}>
                            <div className="flex flex-col ">
                                <div className="flex  text-base font-normal text-[#47566A] pb-1" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                    <FormControl error={!!errors.mcIdType}>
                                        <Controller
                                            name={'mcIdType'}
                                            control={control}
                                            defaultValue={mcIdType}
                                            render={({ field }) =>
                                                <RadioGroup
                                                    {...field}
                                                    row
                                                    onChange={(e) => {
                                                        if(e.target.value === 'national' && !isNationalAvaibale){
                                                            setError('mcIdType', {
                                                                type: 'manual',
                                                                message: 'National ID is already added',
                                                              });                                                            return;
                                                        }
                                                        field.onChange(e);
                                                        handleChange(e); 
                                                        clearErrors('mcIdType');
                                                      }}                                                    
                                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                                    value={field.value}
                                                    className='flex gap-2 px-2 py-1 text-sm text-normal'
                                                >
                                                    <FormControlLabel value="national" control={<Radio />} label="Nation" />
                                                    <FormControlLabel value="state" control={<Radio />} label="State" />
                                                </RadioGroup>
                                            }
                                        />
                                        <FormHelperText>{errors.mcIdType?.message}</FormHelperText>
                                    </FormControl>
                                </div>
                                <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                    <FormControl error={!!errors.idName}>
                                        <SelectTypeInput
                                            name={'idName'}
                                            placeholder={mcIdType === 'national' ? 'Select Country' : 'Select State'}
                                            control={control}
                                            width={'31.6rem'}
                                            height={'2.75rem'}
                                            rules={{
                                                required: "Mandatory information", 
                                            }}                               
                                            options={mcIdType != 'national' ? StateArray.map((item) => ({ value: item, title: item })) : [{value: 'India', title: 'India'}]}
                                            errors={errors}
                                        />
                                    </FormControl>
                                </div>
                            </div>


                            <div className="flex flex-col ">
                                <div className="flex  text-base font-normal text-[#47566A] pb-1" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                    Registration ID
                                    <span className=' text-mb-red' >*</span>
                                </div>
                                <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                    <FormControl error={!!errors.idNumber}>
                                        <TextTypeInput
                                            name={'idNumber'}
                                            placeholder="Enter registration ID"
                                            control={control}
                                            defaultValue=""
                                            width={'31.6rem'}
                                            height={'2.75rem'}
                                            rules={{
                                                required: "Mandatory information",
                                                pattern: {
                                                  value: /^[a-zA-Z0-9]*$/,
                                                  message: "Invalid Input. Only (A-Z) and (0-9) are allowed."                                                
                                                },
                                                minLength: {
                                                  value: 6,
                                                  message: "Minimum 6 characters required"
                                                },
                                                maxLength: {
                                                  value: 12,
                                                  message: "Maximum 12 characters allowed"
                                                }
                                              }} 
                                             errors={errors}
                                        />
                                    </FormControl>
                                </div>
                            </div>

                            <div className=" flex flex-col gap-1">
                                <div className="flex  text-base font-normal text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                    Upload MCI ID Image
                                </div>

                                <div className="flex flex-row basis-3 gap-2">
                                    <Controller
                                        name={'uploadedImages'}
                                        control={control}
                                        render={({ field }) => {
                                            return (
                                                <DocumentFileUpload field={field} setValue={setValue} name={'uploadedImages'} />
                                            )
                                        }} />

                                </div>
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <Divider variant='fullWidth' />

                <DialogActions>
                    <div className="flex gap-2 px-3 py-2">
                        <Button className=' border rounded-lg  text-sm text-semibold p-1  gap-1 ' variant='outlined' onClick={handleClose} style={{ color: '#252D38', borderColor: '#DBE0E6', borderRadius: '0.5rem' }}>Cancel</Button>
                        {/* <Button className=' border rounded-lg  text-sm text-semibold p-1 gap-1  bg-[#A4B0C0]' variant='outlined' onClick={handleSubmit(handleSubmitForm)} style={{ color: '#252D38', borderColor: '#DBE0E6', borderRadius: '0.5rem' }}>Save Details</Button> */}
                        <button
                            className={`${isDirty ? ' border-blue-700 text-white bg-blue-600 ' : ' bg-[#F5F7F8] border-[#DBE0E6] '} "flex flex-col justify-center py-2 px-4 border rounded-lg "`}
                            style={{ color: isDirty ? 'white' : '#A4B0C0' }}
                            onClick={handleSubmit(handleSubmitForm)}                            >
                            Save Details
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}